var isSafari =
	/constructor/i.test(window.HTMLElement) ||
	(function (p) {
		return p.toString() === "[object SafariRemoteNotification]";
	})(
		!window["safari"] ||
			(typeof safari !== "undefined" && window["safari"].pushNotification)
	);

// const iOS = () => {
// 	return (
// 		[
// 			"iPad Simulator",
// 			"iPhone Simulator",
// 			"iPod Simulator",
// 			"iPad",
// 			"iPhone",
// 			"iPod",
// 		].includes(navigator.platform) ||
// 		// iPad on iOS 13 detection
// 		(navigator.userAgent.includes("Mac") && "ontouchend" in document)
// 	);
// };
const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const is_ios = "safari" in window && "pushNotification" in window.safari;
export { isSafari, iOS, is_ios };
